// React imports.
import React from "react";

import { Assessment3bStepsEnum } from "../state";
import { Assessment3bDataReceivedStatusEnum } from "../state";
const Assessment3bQuestions = ({fuelType, state}) => (
    <div>
        {/*OverTargetNoIssues not view anyway*/}
        {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.OverTargetNoIssues
            &&fuelType.viewAnywayFlag != true)
          &&<p>
              This means that you likely do not have a data reliability issue with regard
              to electric baseload data collection
              for  {fuelType.description}   households.
              <br/><br/>  
              No further action is required for  {fuelType.description}   households
              in Assessment #3B. If you want to analyze potential data reliability issues
              for  {fuelType.description}   data anyway, click
              &nbsp;<button className="dataButton"
                      onClick={(changeEvent) => state.assessment3bViewAnyway(changeEvent, fuelType)}>
                      here
                  </button>. Otherwise, click next.
          </p>
        }

        {/*OverTargetNoIssues not view anyway*/}
        {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.OverTargetNoIssues
            &&fuelType.viewAnywayFlag == true)
        &&
          <React.Fragment>
              <p>Since you were not automatically flagged for an issue on this assessment but have selected to explore further anyway, it is likely that you are collecting enough data but having a hard time matching accounts for households that do not heat with electricity. </p>
              <p>Since you need both main heating expenditures and electric baseload expenditures in order to report households on your Performance Data Form it is important to collect 12 months of billing data for both types of energy usage and ensure that you can match a households electric and main heating billing accounts together in your system. Let&rsquo;s explore some reasons why you might be having trouble matching accounts:</p>
              <ol>
                  <li>One or more of your    {fuelType.description}    &nbsp;vendors do not provide billing data with an account number or other unique identifier that can be used for data matching. </li>
                  <li>One or more of your electric vendors do not provide billing data with an account number or other unique identifier that can be used for data matching.</li>
                  <li>Your IT system does not system assign each    {fuelType.description}    &nbsp;household a unique internal identifier for the purposes of matching their    {fuelType.description}    &nbsp;billing account with their electric billing account.</li>
              </ol>
              <p>Let's walk through each of these issues so that you can assess whether any of them might be a problem for your data. Please answer each of the questions below. Depending on your response, each question may ask you to outline an action item to help you address the issue.</p>
              <ol>
                  {/*heatBillingDataIncluesAcctNo*/}
                  <li>
                        Are billing records from   {fuelType.description}    vendors provided with an account number or other unique identifier that can be used for data matching?
                        <br/>
                        <label>
                            <input type="radio"
                                name="heatBillingDataIncluesAcctNoFlag"
                                id="heatBillingDataIncluesAcctNoFlag_true"
                                value="Y"
                                checked={fuelType.heatBillingDataIncluesAcctNoFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatBillingDataIncluesAcctNoFlag"
                                id="heatBillingDataIncluesAcctNoFlag_false"
                                value="N"
                                checked={fuelType.heatBillingDataIncluesAcctNoFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatBillingDataIncluesAcctNoFlag"
                                id="heatBillingDataIncluesAcctNoFlag_dk"
                                value="U"
                                checked={fuelType.heatBillingDataIncluesAcctNoFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.heatBillingDataIncluesAcctNoFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              Vendors should be providing unique identifiers for purposes of data matching.
                            </span>
                          }
                        {fuelType.heatBillingDataIncluesAcctNoFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the main heating vendor and account number of each LIHEAP participating household so you can match data on heat and electric bills to LIHEAP clients. This requires a unique account number for each LIHEAP client. Communicate with vendors to ensure they supply this information.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="heatBillingDataIncluesAcctNoDesc"
                                  id="heatBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.heatBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.heatBillingDataIncluesAcctNoFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether vendors are providing you a unique internal identifier for each household in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="heatBillingDataIncluesAcctNoDesc"
                                  id="heatBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.heatBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {/*electricBillingDataIncluesAcctNo*/}
                  <li>
                        Are billing records from electric vendors provided with an account number or other unique identifier that can be used for data matching?
                        <br/>
                        <label>
                            <input type="radio"
                                name="electricBillingDataIncluesAcctNoFlag"
                                id="electricBillingDataIncluesAcctNoFlag_true"
                                value="Y"
                                checked={fuelType.electricBillingDataIncluesAcctNoFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="electricBillingDataIncluesAcctNoFlag"
                                id="electricBillingDataIncluesAcctNoFlag_false"
                                value="N"
                                checked={fuelType.electricBillingDataIncluesAcctNoFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="electricBillingDataIncluesAcctNoFlag"
                                id="electricBillingDataIncluesAcctNoFlag_dk"
                                value="U"
                                checked={fuelType.electricBillingDataIncluesAcctNoFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.electricBillingDataIncluesAcctNoFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              Vendors should be providing unique identifiers for purposes of data matching.
                            </span>
                          }
                        {fuelType.electricBillingDataIncluesAcctNoFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the electric vendor and account number of each LIHEAP participating household so you can match data on heat and electric bills to LIHEAP clients. This requires a unique account number for each LIHEAP client. Communicate with vendors to ensure they supply this information.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="electricBillingDataIncluesAcctNoDesc"
                                  id="electricBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.electricBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.electricBillingDataIncluesAcctNoFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether vendors are providing you a unique internal identifier for each household in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="electricBillingDataIncluesAcctNoDesc"
                                  id="electricBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.electricBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {/*hhUniqueIdAssigned*/}
                  <li>
                        Does your IT system assign each   {fuelType.description}    household a unique internal identifier for the purposes of matching their   {fuelType.description}    billing account with their electric billing account? 
                        <br/>
                        <label>
                            <input type="radio"
                                name="hhUniqueIdAssignedFlag"
                                id="hhUniqueIdAssignedFlag_true"
                                value="Y"
                                checked={fuelType.hhUniqueIdAssignedFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="hhUniqueIdAssignedFlag"
                                id="hhUniqueIdAssignedFlag_false"
                                value="N"
                                checked={fuelType.hhUniqueIdAssignedFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="hhUniqueIdAssignedFlag"
                                id="hhUniqueIdAssignedFlag_dk"
                                value="U"
                                checked={fuelType.hhUniqueIdAssignedFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.hhUniqueIdAssignedFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>

                              Vendors should be providing unique identifiers for purposes of data matching.
                            </span>
                          }
                        {fuelType.hhUniqueIdAssignedFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Even if you have electric and heat billing data on enough clients, if you cannot match this data to clients, you will not have accurate estimates of the energy expenditures of LIHEAP participating households. Matching accounts sometimes requires the use of internal unique identification number.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="hhUniqueIdAssignedDesc"
                                  id="hhUniqueIdAssignedDesc" style={{width:"100%"}}
                                  value={fuelType.hhUniqueIdAssignedDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.hhUniqueIdAssignedFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether your IT system assigns each household a unique internal identifier in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="hhUniqueIdAssignedDesc"
                                  id="hhUniqueIdAssignedDesc" style={{width:"100%"}}
                                  value={fuelType.hhUniqueIdAssignedDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {(fuelType.heatBillingDataIncluesAcctNoFlag === "Y"
                  && fuelType.electricBillingDataIncluesAcctNoFlag === "Y"
                  && fuelType.hhUniqueIdAssignedFlag === "Y")
                  &&
                  <li>
                      It appears that your potential data reliability issue cannot be explained by the most
                      common reasons we have found for why states may have trouble matching accounts for
                      households that do not heat with electricity. Please contact APPRISE to discuss
                      other potential explanations for this discrepancy. If you have any ideas about
                      what might be causing the discrepancy, please document it in the response box below.
                      <textarea  name="otherReasonMatchingDesc"
                            id="otherReasonMatchingDesc" style={{width:"100%"}}
                            value={fuelType.otherReasonMatchingDesc}
                            onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                  </li>
                }
              </ol>
          </React.Fragment>
        }

        {/*NoHouseholdsServed*/}
        {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.NoHouseholdsServed)
          &&<p>
              No further action is required for   {fuelType.description}   households
              in Assessment #3b.  Click next to continue.
          </p>
        }

        {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.ElecticunderTarget)
          &&
          <React.Fragment>
              {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.ElecticunderTarget)
              &&<div>
                  <p>This means that you are having a harder time collecting electric baseload data for  
                  your   {fuelType.description}    households than you are collecting their main heating expenditure  
                  data. Since you need both main heating expenditures and electric baseload expenditures  
                  in order to report households on your Performance Data Form it is important to collect  
                  12 months of billing data for both types of energy usage. Let&rsquo;s explore some  
                  reasons why you might not have electric data on enough households:</p>
                  <ol >
                      <li>Your LIHEAP application asks clients to provide their vendor and account  
	                  number for their main heating fuel but DOES NOT ask them to provide  
	                  their vendor and account number for electric baseload when the  
	                  household does not heat with electricity.</li>
                      <li>The client waivers included in your application satisfy the privacy  
	                  requirements for main heating vendors but DO NOT satisfy the privacy  
	                  standards for electric vendors.</li>
                      <li>The electric vendors from whom you requested data do not represent  
	                  at least   {fuelType.targetPercentHouseholdsCoveredString}   of your   {fuelType.description}    households.</li>
                      <li>The electric vendors that complied with your data request do not  
	                  represent at least   {fuelType.targetPercentHouseholdsCoveredString}   of your   {fuelType.description}    households.</li>
                      <li>One or more of your electric vendors are only supplying data for  
	                  some, but not all, of the   {fuelType.description}    households they serve. </li>
                      <li>One or more of your electric vendors are only supplying electric  
	                  billing data for households that heat with electricity and not  
	                  households that heat with   {fuelType.description}.</li>
                  </ol>
                  <p>Let's walk through each of these issues so that you can assess whether  
                  any of them might be a problem for your data.&nbsp;</p>
              </div>}  
              <p>
                  Please answer each 
                  of the questions below. Depending on your response, 
                  each question may ask you to outline an action item 
                  to help you address the issue. <strong>If you don't 
                  know the answer to a question please indicate "Don't Know" 
                  and provide your plans to acquire this information from 
                  IT department or programming staff in the response box.</strong>
              </p>
              <ol>

                  {/*appVendorNameAndAccountNo*/}
                  <li>
                        Does your LIHEAP application ask clients to provide vendor name and account number for electric baseload when the household does not heat with electricity?
                        <br/>
                        <label>
                            <input type="radio"
                                name="appVendorNameAndAccountNoFlag"
                                id="appVendorNameAndAccountNoFlag_true"
                                value="Y"
                                checked={fuelType.appVendorNameAndAccountNoFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="appVendorNameAndAccountNoFlag"
                                id="appVendorNameAndAccountNoFlag_false"
                                value="N"
                                checked={fuelType.appVendorNameAndAccountNoFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="appVendorNameAndAccountNoFlag"
                                id="appVendorNameAndAccountNoFlag_dk"
                                value="U"
                                checked={fuelType.appVendorNameAndAccountNoFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >

                        {fuelType.appVendorNameAndAccountNoFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              The LIHEAP application should ask all clients to provide a vendor name and account number.
                            </span>
                          }

                        {fuelType.appVendorNameAndAccountNoFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must acquire electric billing data on households that heat with fuels other than
                              electricity. To acquire this information, you must know the electric vendor and account
                              number of each LIHEAP participating household so that you can match data on heat and
                              electric bills to LIHEAP clients.

                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="appVendorNameAndAccountNoDesc"
                                  id="appVendorNameAndAccountNoDesc" style={{width:"100%"}}
                                  value={fuelType.appVendorNameAndAccountNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}

                        {fuelType.appVendorNameAndAccountNoFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether your LIHEAP application asks for a client's electric vendor 
                              and account number regardless of the client's heating fuel in order to complete
                              a full assessment. You may need to consult your current LIHEAP application or
                              request subgrantees provide you with the local applications they use.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="appVendorNameAndAccountNoDesc"
                                  id="appVendorNameAndAccountNoDesc" style={{width:"100%"}}
                                  value={fuelType.appVendorNameAndAccountNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>

                  {/*clientWaiversMeetElectricVendorRequirements*/}
                  <li>
                        Do the client waivers included in your LIHEAP application satisfy the privacy requirements for electric baseload vendors?
                        <br/>
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetElectricVendorRequirementsFlag"
                                id="clientWaiversMeetElectricVendorRequirementsFlag_true"
                                value="Y"
                                checked={fuelType.clientWaiversMeetElectricVendorRequirementsFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetElectricVendorRequirementsFlag"
                                id="clientWaiversMeetElectricVendorRequirementsFlag_false"
                                value="N"
                                checked={fuelType.clientWaiversMeetElectricVendorRequirementsFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetElectricVendorRequirementsFlag"
                                id="clientWaiversMeetElectricVendorRequirementsFlag_dk"
                                value="U"
                                checked={fuelType.clientWaiversMeetElectricVendorRequirementsFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >

                        {fuelType.clientWaiversMeetElectricVendorRequirementsFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              Client waivers in the LIHEAP application should satisfy vendors' privacy requirements.
                            </span>
                          }

                        {fuelType.clientWaiversMeetElectricVendorRequirementsFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              For electric vendors to send you billing data, they must have satisfactory privacy waivers. You must communicate with your vendors to ensure your waivers meet their requirements.

                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="clientWaiversMeetElectricVendorRequirementsDesc"
                                  id="clientWaiversMeetElectricVendorRequirementsDesc" style={{width:"100%"}}
                                  value={fuelType.clientWaiversMeetElectricVendorRequirementsDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}

                        {fuelType.clientWaiversMeetElectricVendorRequirementsFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether the client waivers in your LIHEAP application satisfy   {fuelType.description}    vendors’ privacy requirements in order to complete a full assessment. You may need to communicate with your vendors to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="clientWaiversMeetElectricVendorRequirementsDesc"
                                  id="clientWaiversMeetElectricVendorRequirementsDesc" style={{width:"100%"}}
                                  value={fuelType.clientWaiversMeetElectricVendorRequirementsDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>

                  {/*electricVendorRequestedServeTargetPercentHh*/}
                  <li>
                        Do the electric vendors from whom you requested data
                        represent    {fuelType.targetPercentHouseholdsCoveredString}    of
                        your   {fuelType.description}    households?
                        <br/>
                        <label>
                            <input type="radio"
                                name="electricVendorRequestedServeTargetPercentHhFlag"
                                id="electricVendorRequestedServeTargetPercentHhFlag_true"
                                value="Y"
                                checked={fuelType.electricVendorRequestedServeTargetPercentHhFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="electricVendorRequestedServeTargetPercentHhFlag"
                                id="electricVendorRequestedServeTargetPercentHhFlag_false"
                                value="N"
                                checked={fuelType.electricVendorRequestedServeTargetPercentHhFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="electricVendorRequestedServeTargetPercentHhFlag"
                                id="electricVendorRequestedServeTargetPercentHhFlag_dk"
                                value="U"
                                checked={fuelType.electricVendorRequestedServeTargetPercentHhFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.electricVendorRequestedServeTargetPercentHhFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              If you do not request data on more than  {fuelType.targetPercentHouseholdsCoveredString}  of households,
                              you cannot acquire data that meets this threshold. Keep track of the number of LIHEAP clients served by each vendor and each vendor’s compliance history. That way, you can request data on enough clients, knowing that some vendors will not comply and that complying vendors will not always be able to supply complete data for 100% of the households they serve.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="electricVendorRequestedServeTargetPercentHhDesc"
                                  id="electricVendorRequestedServeTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.electricVendorRequestedServeTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.electricVendorRequestedServeTargetPercentHhFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the number of households represented by vendors from whom you requested data in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="electricVendorRequestedServeTargetPercentHhDesc"
                                  id="electricVendorRequestedServeTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.electricVendorRequestedServeTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                    </li>


                  {fuelType.electricVendorRequestedServeTargetPercentHhFlag === "Y"
                    &&
                    <li>{/*electricVendorProvidedServeTargetPercentHh*/}
                          Do the electric vendors that complied with your data requested
                          represent    {fuelType.targetPercentHouseholdsCoveredString}    of 
                          your   {fuelType.description}    households? 
                          <br/>
                          <label>
                              <input type="radio"
                                  name="electricVendorProvidedServeTargetPercentHhFlag"
                                  id="electricVendorProvidedServeTargetPercentHhFlag_true"
                                  value="Y"
                                  checked={fuelType.electricVendorProvidedServeTargetPercentHhFlag === "Y"}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                              />
                              <span>Yes</span>
                          </label>
                          &nbsp;&nbsp;
                          <label>
                              <input type="radio"
                                  name="electricVendorProvidedServeTargetPercentHhFlag"
                                  id="electricVendorProvidedServeTargetPercentHhFlag_false"
                                  value="N"
                                  checked={fuelType.electricVendorProvidedServeTargetPercentHhFlag === "N"}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                              />
                              <span>No</span>
                          </label>
                          &nbsp;&nbsp;
                          <label>
                              <input type="radio"
                                  name="electricVendorProvidedServeTargetPercentHhFlag"
                                  id="electricVendorProvidedServeTargetPercentHhFlag_dk"
                                  value="U"
                                  checked={fuelType.electricVendorProvidedServeTargetPercentHhFlag === "U"}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                              />
                              <span>Don't Know</span>
                          </label>
                          <br/ >

                          {fuelType.electricVendorProvidedServeTargetPercentHhFlag === "N"
                            &&
                              <span>
                                <strong>Requires followup.</strong>&nbsp;
                                You must request data from vendors representing more than enough clients so that
                                vendors representing enough clients will comply. Keep track of the number of
                                LIHEAP clients served by each vendor and each vendor’s compliance history.
                                That way, you can request data on enough clients, knowing that some vendors
                                will not comply and that complying vendors will not always be able to supply
                                complete data for 100% of the households they serve.
                                <br/><br/>
                                Please indicate your plans to address this issue in the box below
                                <textarea  name="electricVendorProvidedServeTargetPercentHhDesc"
                                    id="electricVendorProvidedServeTargetPercentHhDesc" style={{width:"100%"}}
                                    value={fuelType.electricVendorProvidedServeTargetPercentHhDesc}
                                    onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                              </span>}
                          {fuelType.electricVendorProvidedServeTargetPercentHhFlag === "U"
                            &&
                              <span>
                                <strong>Requires followup.</strong>&nbsp;
                                You must know the number of households represented by vendors who complied with your data request in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                                <br/><br/>
                                Please indicate your plans for obtaining this information in the box below.
                                <textarea  name="electricVendorProvidedServeTargetPercentHhDesc"
                                    id="electricVendorProvidedServeTargetPercentHhDesc" style={{width:"100%"}}
                                    value={fuelType.electricVendorProvidedServeTargetPercentHhDesc}
                                    onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                              </span>}
                          <br/><br/>
                      </li>
                    }

                  {fuelType.electricVendorProvidedServeTargetPercentHhFlag === "Y"
                    &&
                     <li>{/*electricBillingDataTargetPercentHh*/}
                          Do you have electric billing data on    {fuelType.targetPercentHouseholdsCoveredString}     of   {fuelType.description}    heating households if you include households for whom you do not have a full 12 months of data?
                          <br/>
                          <label>
                              <input type="radio"
                                  name="electricBillingDataTargetPercentHhFlag"
                                  id="electricBillingDataTargetPercentHhFlag_true"
                                  value="Y"
                                  checked={fuelType.electricBillingDataTargetPercentHhFlag === "Y"}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                              />
                              <span>Yes</span>
                          </label>
                          &nbsp;&nbsp;
                          <label>
                              <input type="radio"
                                  name="electricBillingDataTargetPercentHhFlag"
                                  id="electricBillingDataTargetPercentHhFlag_false"
                                  value="N"
                                  checked={fuelType.electricBillingDataTargetPercentHhFlag === "N"}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                              />
                              <span>No</span>
                          </label>
                          &nbsp;&nbsp;
                          <label>
                              <input type="radio"
                                  name="electricBillingDataTargetPercentHhFlag"
                                  id="electricBillingDataTargetPercentHhFlag_dk"
                                  value="U"
                                  checked={fuelType.electricBillingDataTargetPercentHhFlag === "U"}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                              />
                              <span>Don't Know</span>
                          </label>
                          <br/ >

                          {fuelType.electricBillingDataTargetPercentHhFlag === "Y"
                            &&
                              <span>
                                <strong>Requires followup.</strong>&nbsp;
                                It looks like the factor that prevents you from getting heat billing data on enough clients is that compliant vendors are not supplying complete data on enough clients. Make sure your data request to vendors has clear language about what constitutes complete data and keep track of vendors’ compliance histories. That way, you can ensure you request data from vendors representing enough households to ensure data reliability.
                                <br/><br/>
                                Please indicate your plans to address this issue in the box below
                                <textarea  name="electricBillingDataTargetPercentHhDesc"
                                    id="electricBillingDataTargetPercentHhDesc" style={{width:"100%"}}
                                    value={fuelType.electricBillingDataTargetPercentHhDesc}
                                    onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                              </span>}

                          {fuelType.electricBillingDataTargetPercentHhFlag === "N"
                            &&
                              <span>
                                <strong>Requires followup.</strong>&nbsp;
                                You must request data from vendors representing more than enough clients so that vendors representing enough clients will comply. Keep track of the number of LIHEAP clients served by each vendor and each vendor’s compliance history so that you can request data on enough clients, knowing that some vendors will not comply and that complying vendors will not always be able to supply complete data for 100% of the households they serve.
                                <br/><br/>
                                Please indicate your plans to address this issue in the box below
                                <textarea  name="electricBillingDataTargetPercentHhDesc"
                                    id="electricBillingDataTargetPercentHhDesc" style={{width:"100%"}}
                                    value={fuelType.electricBillingDataTargetPercentHhDesc}
                                    onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                              </span>}

                          {fuelType.electricBillingDataTargetPercentHhFlag === "U"
                            &&
                              <span>
                                <strong>Requires followup.</strong>&nbsp;
                                You must know the number of households for which you have electric billing data, whether complete or not, in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                                <br/><br/>
                                Please indicate your plans for obtaining this information in the box below.
                                <textarea  name="electricBillingDataTargetPercentHhDesc"
                                    id="electricBillingDataTargetPercentHhDesc" style={{width:"100%"}}
                                    value={fuelType.electricBillingDataTargetPercentHhDesc}
                                    onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                              </span>}
                          <br/><br/>
                      </li>
                  }

                  {/*vendorsSupplyDataNonElectricHh*/}
                  <li>
                        Are the electric vendors that complied with your data request supplying data for households that heat with   {fuelType.description}    and not just households that heat with electricity?
                        <br/>
                        <label>
                            <input type="radio"
                                name="vendorsSupplyDataNonElectricHhFlag"
                                id="vendorsSupplyDataNonElectricHhFlag_true"
                                value="Y"
                                checked={fuelType.vendorsSupplyDataNonElectricHhFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="vendorsSupplyDataNonElectricHhFlag"
                                id="vendorsSupplyDataNonElectricHhFlag_false"
                                value="N"
                                checked={fuelType.vendorsSupplyDataNonElectricHhFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="vendorsSupplyDataNonElectricHhFlag"
                                id="vendorsSupplyDataNonElectricHhFlag_dk"
                                value="U"
                                checked={fuelType.vendorsSupplyDataNonElectricHhFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >

                        {fuelType.vendorsSupplyDataNonElectricHhFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              Electric vendors should be supplying data for households that heat with all fuels.
                            </span>
                          }
                        {fuelType.vendorsSupplyDataNonElectricHhFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must acquire electric billing data on households that heat with fuels other than electricity. Communicate with your vendors to ensure they supply data on all LIHEAP clients, not just those that use electric heat.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="vendorsSupplyDataNonElectricHhDesc"
                                  id="vendorsSupplyDataNonElectricHhDesc" style={{width:"100%"}}
                                  value={fuelType.vendorsSupplyDataNonElectricHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}

                        {fuelType.vendorsSupplyDataNonElectricHhFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether electric vendors are supplying data on households that heat with other fuels in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="vendorsSupplyDataNonElectricHhDesc"
                                  id="vendorsSupplyDataNonElectricHhDesc" style={{width:"100%"}}
                                  value={fuelType.vendorsSupplyDataNonElectricHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                {(fuelType.appVendorNameAndAccountNoFlag === "Y"
                  && fuelType.clientWaiversMeetElectricVendorRequirementsFlag === "Y"
                  && fuelType.electricVendorRequestedServeTargetPercentHhFlag === "Y"
                  && fuelType.electricVendorProvidedServeTargetPercentHhFlag === "Y"
                  && fuelType.electricBillingDataTargetPercentHhFlag === "Y"
                  && fuelType.vendorsSupplyDataNonElectricHhFlag === "Y")
                  &&<li>
                        It appears that your potential data reliability issue cannot be explained by the most common
                        reasons we have found for why states might not have an electric vendor assigned for at least
                        95% of their assisted households. Please contact APPRISE to discuss other potential explanations
                        for this discrepancy. If you have any ideas about what might be causing the discrepancy, please
                        document it in the response box below.
                        <textarea  name="otherReasonMainHeatDesc"
                              id="otherReasonMainHeatDesc" style={{width:"100%"}}
                              value={fuelType.otherReasonMainHeatDesc}
                              onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </li>
                  }               
              </ol>
          </React.Fragment>
        }

        {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.MainHeatUnderTarget)
          &&
          <React.Fragment>
              <div>
                  <p>This means that you are having a harder time collecting heating data for  
                  your   {fuelType.description}    households than you  
                  are collecting their electric baseload expenditure data. Since you need both  
                  main heating expenditures and electric baseload expenditures in order to report  
                  households on your Performance Data Form it is important to collect 12 months  
                  of billing data for both types of energy usage. Let&rsquo;s explore some reasons  
                  why you might not have electric data on enough households:</p>
                  <ol>
                      <li>The client waivers included in your application satisfy the privacy  
	                  requirements for electric vendors but DO NOT satisfy the privacy  
	                  standards for main heating vendors.</li>
                      <li>The   {fuelType.description}    vendors from  
	                  whom you requested data do not represent at  
	                  least    {fuelType.targetPercentHouseholdsCoveredString}    of  
	                  your   {fuelType.description}    households.</li>
                      <li>The   {fuelType.description}    vendors that  
	                  complied with your data request do not represent at  
	                  least    {fuelType.targetPercentHouseholdsCoveredString}    of  
	                  your   {fuelType.description}    households.</li>
                      <li>One or more of your   {fuelType.description}    vendors are only  
	                  supplying data for some, but not all, of the   {fuelType.description}    households  
	                  they serve. </li>
                  </ol>
                  Let&rsquo;s walk through each of these issues so that you can assess whether any  
                  of them might be a problem for your data. 
              </div>  
              <p>
                  Please answer each 
                  of the questions below. Depending on your response, 
                  each question may ask you to outline an action item 
                  to help you address the issue. <strong>If you don't 
                  know the answer to a question please indicate "Don't Know" 
                  and provide your plans to acquire this information from 
                  IT department or programming staff in the response box.</strong>
              </p>
              <ol>
                  {/*clientWaiversMeetHeatVendorRequirements*/}
                  <li>
                        Do the client waivers included in your LIHEAP application satisfy the privacy requirements for   {fuelType.description}    vendors?
                        <br/>
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetHeatVendorRequirementsFlag"
                                id="clientWaiversMeetHeatVendorRequirementsFlag_true"
                                value="Y"
                                checked={fuelType.clientWaiversMeetHeatVendorRequirementsFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetHeatVendorRequirementsFlag"
                                id="clientWaiversMeetHeatVendorRequirementsFlag_false"
                                value="N"
                                checked={fuelType.clientWaiversMeetHeatVendorRequirementsFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="clientWaiversMeetHeatVendorRequirementsFlag"
                                id="clientWaiversMeetHeatVendorRequirementsFlag_dk"
                                value="U"
                                checked={fuelType.clientWaiversMeetHeatVendorRequirementsFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >

                        {fuelType.clientWaiversMeetHeatVendorRequirementsFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              Client waivers in the LIHEAP application should satisfy vendors’ privacy requirements.
                            </span>
                          }

                        {fuelType.clientWaiversMeetHeatVendorRequirementsFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              For   {fuelType.description}    vendors to send you billing data, they must receive satisfactory privacy waivers. You must communicate with your vendors to ensure your waivers meet their requirements.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="clientWaiversMeetHeatVendorRequirementsDesc"
                                  id="clientWaiversMeetHeatVendorRequirementsDesc" style={{width:"100%"}}
                                  value={fuelType.clientWaiversMeetHeatVendorRequirementsDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}

                        {fuelType.clientWaiversMeetHeatVendorRequirementsFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether the client waivers in your LIHEAP application satisfy   {fuelType.description}    vendors’ privacy requirements in order to complete a full assessment. You may need to communicate with your vendors to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="clientWaiversMeetHeatVendorRequirementsDesc"
                                  id="clientWaiversMeetHeatVendorRequirementsDesc" style={{width:"100%"}}
                                  value={fuelType.clientWaiversMeetHeatVendorRequirementsDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {/*heatVendorRequestedServeTargetPercentHh*/}
                  <li>
                        Do the   {fuelType.description}    vendors from whom you requested data represent    {fuelType.targetPercentHouseholdsCoveredString}    of your   {fuelType.description}    households?
                        <br/>
                        <label>
                            <input type="radio"
                                name="heatVendorRequestedServeTargetPercentHhFlag"
                                id="heatVendorRequestedServeTargetPercentHhFlag_true"
                                value="Y"
                                checked={fuelType.heatVendorRequestedServeTargetPercentHhFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatVendorRequestedServeTargetPercentHhFlag"
                                id="heatVendorRequestedServeTargetPercentHhFlag_false"
                                value="N"
                                checked={fuelType.heatVendorRequestedServeTargetPercentHhFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatVendorRequestedServeTargetPercentHhFlag"
                                id="heatVendorRequestedServeTargetPercentHhFlag_dk"
                                value="U"
                                checked={fuelType.heatVendorRequestedServeTargetPercentHhFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.heatVendorRequestedServeTargetPercentHhFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              If you do not request data on more than    {fuelType.targetPercentHouseholdsCoveredString}    of households, you cannot acquire data that meets this threshold. Keep track of the number of LIHEAP clients served by each vendor and each vendor’s compliance history. That way, you can request data on enough clients, knowing that some vendors will not comply and that complying vendors will not always be able to complete data for 100% of their LIHEAP clients.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="heatVendorRequestedServeTargetPercentHhDesc"
                                  id="heatVendorRequestedServeTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.heatVendorRequestedServeTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}

                        {fuelType.heatVendorRequestedServeTargetPercentHhFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the number of households represented by vendors from whom you requested data in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="heatVendorRequestedServeTargetPercentHhDesc"
                                  id="heatVendorRequestedServeTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.heatVendorRequestedServeTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {fuelType.heatVendorRequestedServeTargetPercentHhFlag === "Y"
                  &&
                  <li>{/*heatVendorProvidedServeTargetPercentHh*/}
                        Do the   {fuelType.description}    vendors that complied with your data requested represent    {fuelType.targetPercentHouseholdsCoveredString}    of your   {fuelType.description}    households?
                        <br/>
                        <label>
                            <input type="radio"
                                name="heatVendorProvidedServeTargetPercentHhFlag"
                                id="heatVendorProvidedServeTargetPercentHhFlag_true"
                                value="Y"
                                checked={fuelType.heatVendorProvidedServeTargetPercentHhFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatVendorProvidedServeTargetPercentHhFlag"
                                id="heatVendorProvidedServeTargetPercentHhFlag_false"
                                value="N"
                                checked={fuelType.heatVendorProvidedServeTargetPercentHhFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatVendorProvidedServeTargetPercentHhFlag"
                                id="heatVendorProvidedServeTargetPercentHhFlag_dk"
                                value="U"
                                checked={fuelType.heatVendorProvidedServeTargetPercentHhFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >

                        {fuelType.heatVendorProvidedServeTargetPercentHhFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must request data from vendors representing more than enough clients so that vendors representing enough clients will comply. Keep track of the number of LIHEAP clients served by each vendor and each vendor’s compliance history. That way, you can request data on enough clients, knowing that some vendors will not comply and that complying vendors will not always be able to complete data for 100% of their LIHEAP clients.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="heatVendorProvidedServeTargetPercentHhDesc"
                                  id="heatVendorProvidedServeTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.heatVendorProvidedServeTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}

                        {fuelType.heatVendorProvidedServeTargetPercentHhFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the number of households represented by vendors who complied with your data request in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="heatVendorProvidedServeTargetPercentHhDesc"
                                  id="heatVendorProvidedServeTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.heatVendorProvidedServeTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>
                  }
                  {fuelType.heatVendorProvidedServeTargetPercentHh === "Y"
                  &&
                  <li>{/*heatBillingDataTargetPercentHh*/}

                        Do you have main heating billing data for {fuelType.targetPercentHouseholdsCoveredString}   of   {fuelType.description}    households if you include households for whom you do not have a full 12 months of data?
                        <br/>
                        <label>
                            <input type="radio"
                                name="heatBillingDataTargetPercentHhFlag"
                                id="heatBillingDataTargetPercentHhFlag_true"
                                value="Y"
                                checked={fuelType.heatBillingDataTargetPercentHhFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatBillingDataTargetPercentHhFlag"
                                id="heatBillingDataTargetPercentHhFlag_false"
                                value="N"
                                checked={fuelType.heatBillingDataTargetPercentHhFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatBillingDataTargetPercentHhFlag"
                                id="heatBillingDataTargetPercentHhFlag_dk"
                                value="U"
                                checked={fuelType.heatBillingDataTargetPercentHhFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >

                        {fuelType.heatBillingDataTargetPercentHhFlag === "Y"
                          && <span>
                              <strong>Requires followup.</strong>   
                              It looks like the factor that prevents you from getting heat billing data on enough clients is that compliant vendors are not supplying complete data on enough clients. Make sure your data request to vendors has clear language about what constitutes complete data and keep track of vendors’ compliance histories. That way, you can ensure you request data from vendors representing enough households to ensure data reliability.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="heatBillingDataTargetPercentHhDesc"
                                  id="heatBillingDataTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.heatBillingDataTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>
                          }

                        {fuelType.heatBillingDataTargetPercentHhFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must request data from vendors representing more than enough clients so that vendors representing enough clients will comply. Keep track of the number of LIHEAP clients served by each vendor and each vendor’s compliance history so that you can request data on enough clients, knowing that some vendors will not comply and that complying vendors will not always be able to complete data for 100% of their LIHEAP clients.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="heatBillingDataTargetPercentHhDesc"
                                  id="heatBillingDataTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.heatBillingDataTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}

                        {fuelType.heatBillingDataTargetPercentHhFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the number of households for which you have heat billing data, whether complete or not, in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="heatBillingDataTargetPercentHhDesc"
                                  id="heatBillingDataTargetPercentHhDesc" style={{width:"100%"}}
                                  value={fuelType.heatBillingDataTargetPercentHhDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>
                  }
              </ol>
          </React.Fragment>
        }
        {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.HhWithBothUnderTarget)
          &&
          <React.Fragment>
              <div>
                  <p>This means that you are collecting enough data but having a hard time matching  
                  accounts for households that do not heat with electricity. Since you need both  
                  main heating expenditures and electric baseload expenditures in order to report  
                  households on your Performance Data Form it is important to collect 12 months  
                  of billing data for both types of energy usage. Let&rsquo;s explore some reasons  
                  why you might not have complete data on enough households:</p>
                  <ol>
                      <li>One or more of your   {fuelType.description}    vendors do not  
	                  provide billing data with an account number or other unique  
	                  identifier that can be used for data matching. </li>
                      <li>One or more of your electric vendors do not provide billing  
	                  data with an account number or other unique identifier that  
	                  can be used for data matching.</li>
                      <li>Your IT system does not system assign  
	                  each   {fuelType.description}    household a unique internal  
	                  identifier for the purposes of matching  
	                  their   {fuelType.description}    billing account with their  
	                  electric billing account.</li>
                  </ol>
                  <p>Let&rsquo;s walk through each of these issues so that you can  
                  assess whether any of them might be a problem for your data.</p>
              </div>  
              <p>
                  Please answer each 
                  of the questions below. Depending on your response, 
                  each question may ask you to outline an action item 
                  to help you address the issue. <strong>If you don't 
                  know the answer to a question please indicate "Don't Know" 
                  and provide your plans to acquire this information from 
                  IT department or programming staff in the response box.</strong>
              </p>
              <ol>
                  {/*heatBillingDataIncluesAcctNo*/}
                  <li>
                        Are billing records from   {fuelType.description}    vendors provided with an account number or other unique identifier that can be used for data matching?
                        <br/>
                        <label>
                            <input type="radio"
                                name="heatBillingDataIncluesAcctNoFlag"
                                id="heatBillingDataIncluesAcctNoFlag_true"
                                value="Y"
                                checked={fuelType.heatBillingDataIncluesAcctNoFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatBillingDataIncluesAcctNoFlag"
                                id="heatBillingDataIncluesAcctNoFlag_false"
                                value="N"
                                checked={fuelType.heatBillingDataIncluesAcctNoFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="heatBillingDataIncluesAcctNoFlag"
                                id="heatBillingDataIncluesAcctNoFlag_dk"
                                value="U"
                                checked={fuelType.heatBillingDataIncluesAcctNoFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.heatBillingDataIncluesAcctNoFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              Vendors should be providing unique identifiers for purposes of data matching.
                            </span>
                          }
                        {fuelType.heatBillingDataIncluesAcctNoFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the main heating vendor and account number of each LIHEAP participating household so you can match data on heat and electric bills to LIHEAP clients. This requires a unique account number for each LIHEAP client. Communicate with vendors to ensure they supply this information.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="heatBillingDataIncluesAcctNoDesc"
                                  id="heatBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.heatBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.heatBillingDataIncluesAcctNoFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether vendors are providing you a unique internal identifier for each household in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="heatBillingDataIncluesAcctNoDesc"
                                  id="heatBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.heatBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {/*electricBillingDataIncluesAcctNo*/}
                  <li>
                        Are billing records from electric vendors provided with an account number or other unique identifier that can be used for data matching?
                        <br/>
                        <label>
                            <input type="radio"
                                name="electricBillingDataIncluesAcctNoFlag"
                                id="electricBillingDataIncluesAcctNoFlag_true"
                                value="Y"
                                checked={fuelType.electricBillingDataIncluesAcctNoFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="electricBillingDataIncluesAcctNoFlag"
                                id="electricBillingDataIncluesAcctNoFlag_false"
                                value="N"
                                checked={fuelType.electricBillingDataIncluesAcctNoFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="electricBillingDataIncluesAcctNoFlag"
                                id="electricBillingDataIncluesAcctNoFlag_dk"
                                value="U"
                                checked={fuelType.electricBillingDataIncluesAcctNoFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.electricBillingDataIncluesAcctNoFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>   
                              Vendors should be providing unique identifiers for purposes of data matching.
                            </span>
                          }
                        {fuelType.electricBillingDataIncluesAcctNoFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know the electric vendor and account number of each LIHEAP participating household so you can match data on heat and electric bills to LIHEAP clients. This requires a unique account number for each LIHEAP client. Communicate with vendors to ensure they supply this information.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="electricBillingDataIncluesAcctNoDesc"
                                  id="electricBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.electricBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.electricBillingDataIncluesAcctNoFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether vendors are providing you a unique internal identifier for each household in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="electricBillingDataIncluesAcctNoDesc"
                                  id="electricBillingDataIncluesAcctNoDesc" style={{width:"100%"}}
                                  value={fuelType.electricBillingDataIncluesAcctNoDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {/*hhUniqueIdAssigned*/}
                  <li>
                        Does your IT system assign each   {fuelType.description}    household a unique internal identifier for the purposes of matching their   {fuelType.description}    billing account with their electric billing account? 
                        <br/>
                        <label>
                            <input type="radio"
                                name="hhUniqueIdAssignedFlag"
                                id="hhUniqueIdAssignedFlag_true"
                                value="Y"
                                checked={fuelType.hhUniqueIdAssignedFlag === "Y"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Yes</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="hhUniqueIdAssignedFlag"
                                id="hhUniqueIdAssignedFlag_false"
                                value="N"
                                checked={fuelType.hhUniqueIdAssignedFlag === "N"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>No</span>
                        </label>
                        &nbsp;&nbsp;
                        <label>
                            <input type="radio"
                                name="hhUniqueIdAssignedFlag"
                                id="hhUniqueIdAssignedFlag_dk"
                                value="U"
                                checked={fuelType.hhUniqueIdAssignedFlag === "U"}
                                onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}
                            />
                            <span>Don't Know</span>
                        </label>
                        <br/ >
                        {fuelType.hhUniqueIdAssignedFlag === "Y"
                          && <span>
                              <strong>No action needed.  </strong>

                              Vendors should be providing unique identifiers for purposes of data matching.
                            </span>
                          }
                        {fuelType.hhUniqueIdAssignedFlag === "N"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              Even if you have electric and heat billing data on enough clients, if you cannot match this data to clients, you will not have accurate estimates of the energy expenditures of LIHEAP participating households. Matching accounts sometimes requires the use of internal unique identification number.
                              <br/><br/>
                              Please indicate your plans to address this issue in the box below
                              <textarea  name="hhUniqueIdAssignedDesc"
                                  id="hhUniqueIdAssignedDesc" style={{width:"100%"}}
                                  value={fuelType.hhUniqueIdAssignedDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        {fuelType.hhUniqueIdAssignedFlag === "U"
                          &&
                            <span>
                              <strong>Requires followup.</strong>&nbsp;
                              You must know whether your IT system assigns each household a unique internal identifier in order to complete a full assessment. You may need to consult your IT staff to find out this information.
                              <br/><br/>
                              Please indicate your plans for obtaining this information in the box below.
                              <textarea  name="hhUniqueIdAssignedDesc"
                                  id="hhUniqueIdAssignedDesc" style={{width:"100%"}}
                                  value={fuelType.hhUniqueIdAssignedDesc}
                                  onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                            </span>}
                        <br/><br/>
                  </li>

                  {(fuelType.heatBillingDataIncluesAcctNoFlag === "Y"
                  && fuelType.electricBillingDataIncluesAcctNoFlag === "Y"
                  && fuelType.hhUniqueIdAssignedFlag === "Y")
                  &&
                  <li>
                      It appears that your potential data reliability issue cannot be explained by the most
                      common reasons we have found for why states may have trouble matching accounts for
                      households that do not heat with electricity. Please contact APPRISE to discuss
                      other potential explanations for this discrepancy. If you have any ideas about
                      what might be causing the discrepancy, please document it in the response box below.
                      <textarea  name="otherReasonMatchingDesc"
                            id="otherReasonMatchingDesc" style={{width:"100%"}}
                            value={fuelType.otherReasonMatchingDesc}
                            onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
                  </li>
                }
              </ol>
          </React.Fragment>
        }

        {(fuelType.hhDataReceivedStatus3b == Assessment3bDataReceivedStatusEnum.NeitherOverTarget)
          &&
          <div>
              <p>
                  This means that you have other larger issues going on with your data collection process. Please complete assessments 2 and 3 of the Main Heating Tool and Assessment 2A, 2B, and 3A of the Electric Baseload Tool to learn more. 
              </p>
              <p>
                  In the response box below, please write yourself a reminder to visit those other assessments for more information. 
                  <textarea  name="otherReasonMatchingDesc"
                        id="otherReasonMatchingDesc" style={{width:"100%"}}
                        value={fuelType.otherReasonMatchingDesc}
                        onChange={(changeEvent) => state.assessment3bFieldChangeHandler(changeEvent, fuelType)}></textarea>
              </p>
          </div>
        }


    </div>
);
export default Assessment3bQuestions;
